import * as React from 'react';
import { ukCountry } from '../../core/constants';
import { country } from '../../config.local';
import FooterLink from './FooterLink';

const TermsLink = (props: Props) => {
	const text = props.text ?? 'Terms';
	const getUrl = () => {
		if (country === ukCountry) return 'https://vetting.com/en-gb/terms-conditions';
		return 'https://vetting.com/en-au/terms-conditions';
	};
	return <FooterLink text={text} href={getUrl()} />;
};

interface Props {
	text?: string;
}

TermsLink.defaultProps = {
	text: null
};

export default TermsLink;
